import { screenSizeDetection as _, getCmsProperty as t, sourcePoint as u } from "@sunrise/shared";
import { TCF as L } from "@sunrise/types";
import { defineComponent as v, ref as f, computed as l, onMounted as I } from "vue";
import { Properties as n } from "./index573.js";
import { iframeResize as O } from "iframe-resizer";
const z = v({
  name: "MsIframe",
  props: {
    cmsContent: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { isScreenM: i, isScreenL: m } = _(), o = !!t(n.WAIT_FOR_CONSENT, e.cmsContent, !1), c = f(!o), C = t("meinestadt/types#isFullscreen", e.cmsContent, !1), r = f(null), d = l(() => m.value ? t(n.URL_DESKTOP, e.cmsContent) : i.value ? t(n.URL_TABLET, e.cmsContent) : t(n.URL_MOBILE, e.cmsContent)), T = l(() => m.value ? t(n.HEIGHT_DESKTOP, e.cmsContent) : i.value ? t(n.HEIGHT_TABLET, e.cmsContent) : t(n.HEIGHT_MOBILE, e.cmsContent));
    I(() => {
      if (o) {
        u.onConsentAvailablePromise().then((s) => {
          c.value = u.hasConsent(L.Purpose.STORAGE, s);
        });
        return;
      }
      a();
    });
    function h() {
      o && a();
    }
    function a() {
      if (C || !r.value)
        return;
      const s = t(
        "meinestadt/iframe#resizerConfWidth",
        e.cmsContent,
        "scroll"
      ), E = t(
        "meinestadt/iframe#resizerConfHeight",
        e.cmsContent,
        "lowestElement"
      );
      O(
        {
          heightCalculationMethod: E,
          widthCalculationMethod: s
        },
        r.value
      );
    }
    return {
      url: d,
      height: T,
      hasUserConsent: c,
      waitForConsent: o,
      onLoad: h,
      iframeRef: r
    };
  }
});
export {
  z as default
};
